<template>
  <div id="todo-app" class="  relative todo-height text-left">
    <vs-sidebar id="sideBar" class="items-no-padding set-background" parent="#todo-app" :class="isSidebarActive ? 'open':'closed' " :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isSidebarActive">
        <!--For Later Use-->
        <TodoAddNew v-if="false" />
        <div class="filters border border-solid">
            <div class="filterItems">
                <div style="height:60px; width:100%;"></div>

                <h2>Filters</h2>
                <div class="todo-tags sm:ml-2 sm:my-0 my-2 flex filterPriority pointer filterFilters" :class="toDoItems ? 'selectedFilter':''">
                    <h4 @click="todoFilterMethod">To Do</h4>
                </div>

                <div class="todo-tags sm:ml-2 sm:my-0 my-2 flex filterPriority pointer filterFilters" :class="completedFilter ? 'selectedFilter':''">
                    <h4 @click="completedFilterMethod">Completed</h4>
                </div>

                <div class="todo-tags sm:ml-2 sm:my-0 my-2 flex filterPriority pointer filterFilters" :class="currFilter ? 'selectedFilter':''" >
                    <h4  @click="allFilter">ALL</h4>
                </div>
                
                <hr class="border">
                <h2>Priority</h2>
                <div class="todo-tags sm:ml-2 sm:my-0 my-2 flex filterPriority" v-for="(tag, tagIndex) in tags " :key="tagIndex" @click="priorityFilter(tagIndex)">
                    <vs-chip  class="filterChip" :class="selectedPriority == tagIndex ? 'selectedPriority':'' " >
                        <div class="icondiv" :class="tag.text =='Low' ? 'low' : tag.text =='Medium' ? 'medium': 'high'" ></div>
                        <h5 style="margin:0 !important">{{tag.text}}</h5>
                    </vs-chip>
                </div>

                <hr class="border">
                <h2>Classrooms</h2>
                <div class="todo-tags sm:ml-2 sm:my-0 my-2 flex filterFilters" :class="classroomId.id == clrItem.id? 'selectedFilter':''" v-for="(clrItem, classIndex) in classrooms " :key="'B' + classIndex" @click="classroomFilter(clrItem.id)">
                    <h4>{{clrItem.name}}</h4>
                </div>
            </div>
            
        </div>
        </vs-sidebar>
        <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content">

            <div class="flex d-theme-dark-bg items-center border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light">

                <!-- TOGGLE SIDEBAR BUTTON -->
                <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" id="menuIcon" style="z-index: 207899;" icon="MenuIcon" @click.stop="toggleTodoSidebar()" />

                <!-- SEARCH BAR -->
                <vs-input icon-no-border size="large" icon-pack="feather" icon="icon-search" placeholder="Search..." :blur="todoFilter" v-model="searchQuery"  class=" vs-input-no-shdow-focus w-full" />
            </div>

            <!-- TO-DO LIST -->
            <component :is="scrollbarTag" class="todo-content-scroll-area" :settings="settings" ref="taskListPS" :key="$vs.rtl">

                 <transition-group class="todo-list" name="list-enter-up" tag="ul" appear>
                    <li
                      class="cursor-pointer todo_todo-item"
                      v-for="(task, index) in searchQuery.length == 0 ? filterList :todoFilter"
                      :key="'B' + String(task.id)"
                      :style="[{transitionDelay: (index * 0.1) + 's'}]">

                      <todo-task :taskId="task.id" @showDisplayPrompt="showDisplayPrompt(filterList[index])" :taskLocal="task" :key="String(task.title) + String(task.description)" />
                    
                    </li>
                </transition-group>
             </component> 
            <!-- /TODO LIST -->

        </div>

        <!-- EDIT TODO DIALOG -->

        <div>
            <vs-popup title="Edit Task" id="end-chat-popup" :active.sync="displayPrompt">
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <label>Title</label>
                        <vs-input :disabled="true" v-validate="'required'" name="title" class="w-full mb-2" placeholder="Title" v-model="tasktoEdit.title" />
                        <label>Description</label>
                        <vs-textarea :disabled="true" rows="5"  v-model="tasktoEdit.description" />
                        <vs-chip v-for="(tag, index) in tasktoEdit.tags" :key="index">
                            <div class="icondiv" :class="tag.text =='Low' ? 'low' : tag.text =='Medium' ? 'medium': 'high' " ></div>
                            <span>{{ tag.text | capitalize }}</span>
                        </vs-chip>
                        <div class="vx-row w-full">
                            <div class="ml-3 w-2/4"><h6>{{"Due Date:"}}</h6></div>
                            <div class="vx-col w-2/4"><p>{{tasktoEdit.dueDate}}</p></div>
                        </div>
                    </div>
                </div>
                <vs-button color="warning" class="float-right mt-1" @click="cancelTodo()">Cancel</vs-button>
                <vs-button color="success" class="float-right mt-1 mr-2" @click="popupText.includes('Complete') ? completeTask(): removeComplete()">{{popupText}}</vs-button>
            </vs-popup>
        </div>
    </div>
</template>

<script>
import TodoAddNew          from '../pages/ContentComponents/TodoAddNew.vue'
import TodoTask          from '../pages/ContentComponents/TodoTask.vue'
import TodoEdit          from '../pages/ContentComponents/TodoEdit.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from 'moment'
export default {
    data(){
        return{
            currFilter: false,
            clickNotClose: false,
            displayPrompt: false,
            taskIdToEdit: 0,
            isSidebarActive: false,
            searchQuery:"",
            settings : {
                maxScrollbarLength : 60,
                wheelSpeed         : 0.30
            },
            listTasks:[],
            tasktoEdit:{},
            tags:{},
            taskList:[],
            filterList:[],
            selectedPriority:null,
            currentDay:'',
            completedList:[],
            completedHomeworkItem:{
                id:0,
                classroomId:0,

            },
            completedFilter: false,
            classrooms:[],
            windowWidth: window.innerWidth,
            toDoItems:false,
            classroomId:{
                id:0,
            },
            popupText:"",
        }
    },
    watch: {
        windowWidth(newHeight, oldHeight) {
            var self= this;
            if(screen.width >920){
                self.isSidebarActive = true;
            }
        }
    },
    components:{
        TodoTask,
        TodoAddNew,
        TodoEdit,
        VuePerfectScrollbar,
        moment
    },
    computed:{
        
        todoFilter () {
            var self = this;
            if(self.searchQuery.length != 0){
                self.currFilter = false;
                self.selectedPriority = null;
                self.currFilter = false;
                self.completedFilter = false;
                self.toDoItems = false;
                return self.filterList = self.listTasks.filter(item => item.title.toLowerCase().includes(self.searchQuery.toLowerCase()));
            }
            else{
                self.allFilter();
                return self.filterList = self.listTasks;
            }
                
        },
        scrollbarTag: state => {
            return state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
        },
    },
    methods:{
        
        showDisplayPrompt (item) {
            var self = this;
            document.getElementById("menuIcon").style.display = 'none';
            self.popupText ="Complete";
            self.completedList.forEach(element => {
                if(item.id == element.homeworkBookItemId)
                {
                    self.popupText ="Uncomplete";
                }
            });
            this.tasktoEdit = item;
            this.taskIdToEdit  = item.id;
            this.displayPrompt = true;

            
        },
        hidePrompt () {
        this.displayPrompt = false
        },
        setSidebarWidth () {
        if (this.windowWidth < 992) {
            this.isSidebarActive = this.clickNotClose = false
        } else {
            this.isSidebarActive = this.clickNotClose = true
        }
        },
        toggleTodoSidebar() {
            var self= this;
            self.isSidebarActive = !self.isSidebarActive;
        },
        getTags(){
            var self = this;
            var onSuccess = response =>{
                self.tags = response.data;
                
                self.taskList =self.listTasks;
                self.getHomeWorkList();
            };
            self.$ajaxGet(self, "HomeworkBook/GetHomeworkTagListForSite", onSuccess);
        },
        getHomeWorkList(){
            var self = this;
            var onSuccess = response =>{
                self.listTasks = response.data;
                self.listTasks.forEach(element => {
                    var dateString = new Date(Date.parse(element.dueDate));
                    element.dueDate = moment(dateString.toISOString()).format("dddd, Do MMMM YYYY");
                });
                self.filterList = self.listTasks.forEach(element => {
                    element.tags = self.tags.filter(function(item){return item.value == element.homeworkBookTagId});
                });
                self.getCompletedList();
                self.todoFilterMethod();
            };
            self.$ajaxGet(self, "HomeworkBook/GetListForStudent" , onSuccess);
        },
        priorityFilter(index){
            var self = this;
            self.selectedPriority = index;
            self.filterList = self.listTasks.filter(item => item.tags[0].value == index +1);
            self.currFilter = false;
            self.toDoItems = false;
            self.classroomId.id =0;
            self.setSidebarActive();
        },
        allFilter(){
            var self = this;
            self.filterList = self.listTasks;
            self.searchQuery = '';
            self.selectedPriority = null;
            self.currFilter = true;
            self.completedFilter = false;
            self.toDoItems = false;
            self.classroomId.id =0;
            self.setSidebarActive();
        },
        getClassrooms(){
            var self = this;
            self.classroomId = self.$route.query;
            var onSuccess = response =>{
                self.classrooms = response.data;
            };
            self.$ajaxGet(self, "Company/GetStudentClassrooms" , onSuccess);
        },
        classroomFilter(selectedId){
            var self = this;
            if(self.classroomId == self.$route.query && self.classroomId.id == selectedId){

            }
            else{
                self.classroomId.id = selectedId;
            }
            self.filterList = self.listTasks.filter(item=> item.classroomId == selectedId);
            self.searchQuery = '';
            self.selectedPriority = null;
            self.currFilter = false;
            self.completedFilter = false;
            self.toDoItems = false;
            self.setSidebarActive();
        },
        todoFilterMethod(){
            var self = this;
            var filteredArray  = self.listTasks.filter(function(array_el){
                return self.completedList.filter(function(anotherOne_el){
                    return anotherOne_el.homeworkBookItemId == array_el.id;
                }).length == 0
            });
            self.filterList = filteredArray;

            self.searchQuery = '';
            self.selectedPriority = null;
            self.currFilter = false;
            self.completedFilter = false;
            self.toDoItems = true;
            self.classroomId.id = 0;
            self.setSidebarActive(); 
            
        },
        completedFilterMethod(){
            var self = this;
            self.filterList=[];
            self.completedList.forEach(element => {
                var temp = self.listTasks.filter(item => item.id == element.homeworkBookItemId)
                if(temp.length){
                    self.filterList.push(temp[0])
                }
            });
            self.classroomId.id = 0;
            self.searchQuery = '';
            self.selectedPriority = null;
            self.currFilter = false;
            self.completedFilter = true;
            self.toDoItems = false;
            self.setSidebarActive();
            
        },
        getCompletedList(){
            var self = this;
            var onSuccess = response =>{
                self.completedList = response.data;
                self.todoFilterMethod();
            };
            self.$ajaxGet(self, "HomeworkBook/CompletedListForStudent" , onSuccess);
        },
        completeTask(){
            var self= this;
            self.completedHomeworkItem.id = self.taskIdToEdit;
            var onSuccess = response =>{
                self.getHomeWorkList();
                document.getElementById("menuIcon").style.display = 'inline-flex';
                self.hidePrompt();
            };
            self.$ajaxPost(self, "HomeworkBook/CompletedHomeworkItem", self.completedHomeworkItem , onSuccess);
        },
        removeComplete(){
            var self = this;
            var self= this;
            self.completedHomeworkItem.id = self.taskIdToEdit;
            var onSuccess = response =>{
                self.getHomeWorkList();
                document.getElementById("menuIcon").style.display = 'inline-flex';
                self.hidePrompt();
            };
            self.$ajaxPost(self, "HomeworkBook/removeCompleteHomeworkItem", self.completedHomeworkItem , onSuccess);
        },
        setSidebarActive(){
            var self = this;
            if(screen.width >920){
                self.isSidebarActive = true;
            }
            else
                self.isSidebarActive = false;
        },
        onResize() {
            this.windowWidth = window.innerWidth;
        },
        cancelTodo(){
            this.displayPrompt = false;
        },       
    },
    mounted(){
        var self = this;
        self.setSidebarWidth();
        self.getTags();
        self.getClassrooms();
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })
        
    }
}
</script>

<style lang="scss">
#todo-app{
    border-color: #414561 !important;
        .vs-sidebar--background{
        position: absolute;
    }
    .vs-sidebar{
        width: 250px !important;
    }
    .todo-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 70px);

        &:not(.ps) {
          overflow-y: auto;
        }
    }
    .todo-content-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 60px);
        max-height: 79vh;

        &:not(.ps) {
          overflow-y: auto;
        }
    }

    // TRANSITION
    .todo_todo-item {
        transition: all .35s;
    }

    .list-item-component {
        transition: background-color .2s, transform .2s;
        border-top: 1px solid #dae1e7;
        &:hover {
            // background-color: #eee;
            transform: translateY(-4px);
			box-shadow: 0px 3px 10px 0px #ccc;
            transition: all 0.2s;
        }
    }

    .todo-list {
      .todo-tags {
        .con-vs-chip {
          margin-right: 2px !important;
        }
      }
    }
    .border{
        border-color: #414561 !important;
    }
    .icondiv{
    width: 0.5rem !important;
    height: 0.5rem !important;
    border-radius: 9999px !important;
    margin-right: 0.25rem !important;
    
  }
    .filterPriority{
        display: flex;
        flex-direction: column;
        width: fit-content !important;
        justify-content: center;
        cursor: pointer;
    }
  .low{
    background-color: green;
  }
  .medium{
    background-color: orange;
  }
  .high{
    background-color: red;
  }
  .filterChip{
    display:flex; 
    justify-content:center;
    cursor: pointer;
  }
  .filterFilters{
    cursor: pointer;
  }
  .filterFilters.selectedFilter{
    h4{
        color: whitesmoke !important;
    }
  }
  .filters{
      h4{
        color: gray;
    }
  }
  .selectedPriority{
    transform: scale(1.2);
    transition: transform 300ms ease-in-out;
    box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.4);
    
  }
  
}
.todo-height{
    .todo-content-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 60px);
        max-height: 79vh;

        &:not(.ps) {
          overflow-y: auto;
        }
    }
}
.vs-sidebar--items{
    overflow: visible !important;
}
.filters{
    text-align: left;
}
.filterItems{
    width: 90%;
    margin: 0 auto;
}
.set-background{
    .filters {
        background: #262c49;
    }
    
};

@media screen and(max-width: 920px) {
    .sidebar-spacer{
        width: 100%;
        margin: 5px auto;
    }
    
    #todo-app .todo-content-scroll-area{
        max-height: calc(100vh - 178px);
    }

    #sideBar.open > div{
        width: 100% !important;
        height: fit-content !important;
    }
    #sideBar.closed > div{
        width: 0;
        height: fit-content;
        overflow: hidden;
    }
}
</style>